/**
 * Holds a staff-issued invite token between opening /claim and completing
 * signup or login.
 *
 * sessionStorage, not localStorage: an invite is single-use and short-lived,
 * and it should not outlive the tab that opened it.
 *
 * The token is a bearer capability — it binds an account to a client. Never
 * log it, never put it in a URL we construct, never render it.
 */
const KEY = 'pgi.invite.token';

export const stashInviteToken = (token) => {
  if (!token) return;
  try {
    window.sessionStorage.setItem(KEY, token);
  } catch {
    // Private browsing or blocked storage. The claim simply will not
    // auto-apply; the client lands in the pending state and staff link them
    // by hand, which is the same path as an uninvited signup.
  }
};

export const takeInviteToken = () => {
  try {
    const token = window.sessionStorage.getItem(KEY);
    if (token) window.sessionStorage.removeItem(KEY);
    return token;
  } catch {
    return null;
  }
};
